
import React, { useEffect, useState } from 'react';

import { ToastContainer, toast } from "react-toastify";
import { GetAllAcademicsTypes, GetAllBranches, SaveAcademicsTypes, savebranchyearprice, UpdateAcademicsTypes, updatebranchyearprice } from '../../../../services/CommonService';





const AddBranchYearPrice = ({ updateprop }) => {


    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const fields = {
        branchid: '',
        status: '',
        academictypeid: '',
        year: '',
        price: '',

    }

    const errors = {
        branchid: '',
        status: '',
        academictypeid: '',
        year: '',
        price: '',


    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [branches, setBranches] = useState([])
    const [academictypes, setAcademicTypes] = useState([])


    useEffect(() => {
        setFieldData();
        getBranches()
        getAcademicTypes()


    }, []);



    const { branchid, status, year, academictypeid, price } = formfields;

    const setFieldData = async () => {
        if (updateprop?.id) {
            setFromFields(updateprop);

        }
    }


    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;



        if (!fields["branchid"]) {
            formIsValid = false;
            errors["branchid"] = "*Please select branch .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    const getBranches = async () => {
        const reqparams = {
            pageno: "-1",
            status: "Active"
        }
        const Response = await GetAllBranches(reqparams)
        setBranches(Response.data)
        console.log("Branch response", Response);

    }

    const getAcademicTypes = async () => {
        const reqparams = {
            pageno: "-1",
            status: "Active"
        }
        const respData = await GetAllAcademicsTypes(reqparams);
        setAcademicTypes(respData.data)
        console.log("Types response", respData);

    }

    const submitForm = async () => {
        console.log("formfields",formfields);
        const isValid = await validateForm();
        if (isValid) {
            if (!formfields.id) {
                //save
                const Response = await savebranchyearprice(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await updatebranchyearprice(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }


    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Branch
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='branchid'
                    onChange={handleChange} value={branchid}>
                    <option value="">Select Branch</option>
                    {branches?.map(item => (
                        <option
                            key={item.id}
                            value={item.id}
                        >
                            {item.name}
                        </option>
                    ))}
                </select>

            </div>
            <div className="errorMsg">{errorFields.year}</div>
        </div>

        
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
               Academic typeid
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='academictypeid'
                    onChange={handleChange} value={academictypeid}>
                    <option value="">Select Academic Type</option>
                    {academictypes?.map(item => (
                        <option
                            key={item.id}
                            value={item.id}
                        >
                            {item.name}
                        </option>
                    ))}
                </select>

            </div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Year
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='year'
                    onChange={handleChange} value={year}>
                    <option value="">Select Year</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.year}</div>
        </div>


        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Price
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="Price"
                    name="price"
                    className="form-control"

                    value={price} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.price}</div>
        </div>


        <br />

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Status
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='status'
                    onChange={handleChange} value={status}>
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.status}</div>
        </div>



        <br />
        <div className="form-group">
            <button onClick={submitForm} className="btn btn-primary" type="button"
            >Save</button>
        </div>

    </>)

}

export default AddBranchYearPrice